import React from 'react';
import { Helmet } from 'react-helmet';
import { AuthProvider } from './services/AuthProvider';
import './App.css';
import Routes from './routes/routes';

let backendUrl;
let aadb2cHostUrl;
const jiraUrl = 'https://tdf.atlassian.net/';
const appInsightsUrl = 'https://dc.services.visualstudio.com';
const qualifUrl = 'https://prod-91.westeurope.logic.azure.com:443';
const prodUrl = 'https://prod-196.westeurope.logic.azure.com:443';
const env = process.env.REACT_APP_STAGE;

switch (env) {
  case 'dev':
    backendUrl = 'https://wolfback.rcgwd.iasp.tgscloud.net';
    aadb2cHostUrl = 'https://rclistad.b2clogin.com';
    break;
  case 'qa':
    backendUrl = 'https://wolfback.rcgwq.iasp.tgscloud.net';
    aadb2cHostUrl = 'https://rclistai.b2clogin.com';
    console.log('Env Name is backendUrl QA => ');
    break;
  case 'prod':
    backendUrl = 'https://wolfback.rcgwp.iasp.tgscloud.net';
    aadb2cHostUrl = 'https://rclistap.b2clogin.com';
    console.log('Env Name is backendUrl PROD => ');
    break;
  default:
    backendUrl = 'http://localhost:8085';
    aadb2cHostUrl = 'https://rclistai.b2clogin.com';
    console.log('Env Name is backendUrl default => ');
}

function App() {
  return (
    <div>
      <div className="AppContainer">
        <Helmet>
          <meta
            httpEquiv="Content-Security-Policy"
            content={`connect-src 'self' ${backendUrl} ${aadb2cHostUrl} ${jiraUrl} ${appInsightsUrl} ${qualifUrl} ${prodUrl};
            manifest-src 'self';
            script-src-elem 'unsafe-inline' ${jiraUrl};
            style-src-elem 'self' 'unsafe-inline';`}
          />
        </Helmet>
      </div>
      <AuthProvider>
        <Routes />
      </AuthProvider>
    </div>
  );
}

export default App;
